'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var ACCOUNTS_SERVICE_API_URL = 'https://accounts.cimpress.io/api/v1/accounts';
var ACCOUNT_CLAIM = exports.ACCOUNT_CLAIM = 'https://claims.cimpress.io/account';
var ACCOUNTS_MANAGEMENT_DASHBOARD_URL = exports.ACCOUNTS_MANAGEMENT_DASHBOARD_URL = 'https://accounts.cimpress.io';

var fetchAccountDetails = exports.fetchAccountDetails = function fetchAccountDetails(_ref) {
  var account = _ref.account,
      accessToken = _ref.accessToken;
  return fetch(ACCOUNTS_SERVICE_API_URL + '/' + account, {
    method: 'GET',
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken
    })
  }).then(function (response) {
    if (response.status === 200) {
      return response.json();
    } else {
      return {};
    }
  }).catch(function (error) {
    console.error(error);
    return {};
  });
};

;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ACCOUNT_CLAIM, 'ACCOUNT_CLAIM', 'src/services/account.js');
  reactHotLoader.register(ACCOUNTS_MANAGEMENT_DASHBOARD_URL, 'ACCOUNTS_MANAGEMENT_DASHBOARD_URL', 'src/services/account.js');
  reactHotLoader.register(fetchAccountDetails, 'fetchAccountDetails', 'src/services/account.js');
  reactHotLoader.register(ACCOUNTS_SERVICE_API_URL, 'ACCOUNTS_SERVICE_API_URL', 'src/services/account.js');
  leaveModule(module);
})();

;